import { ShieldAlert } from 'lucide-react';
import InputField from './InputField';
import type { WizardDaten } from '@/lib/mietwagen-wizard-validation';

interface Props {
  daten: WizardDaten;
  onChange: (updated: Partial<WizardDaten>) => void;
}

export default function Step2Schaden({ daten, onChange }: Props) {
  const set = (field: keyof WizardDaten, value: unknown) => onChange({ [field]: value });

  return (
    <div className="space-y-5 p-5">
      <div>
        <div className="flex items-center gap-2 mb-3">
          <ShieldAlert className="w-4 h-4 text-orange-600" />
          <h3 className="text-sm font-semibold">Schaden & Versicherung</h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          <InputField required label="Versicherung" value={daten.versicherung_name} onChange={v => set('versicherung_name', v)} />
          <InputField label="Adresse" value={daten.versicherung_adresse} onChange={v => set('versicherung_adresse', v)} />
          <InputField label="PLZ Ort" value={daten.versicherung_plz_ort} onChange={v => set('versicherung_plz_ort', v)} />
          <InputField required label="Schadennummer" value={daten.schadennummer} onChange={v => set('schadennummer', v)} />
          <InputField required label="Unfalldatum" value={daten.unfalldatum} onChange={v => set('unfalldatum', v)} type="date" />
          <InputField label="Unfallort" value={daten.unfallort} onChange={v => set('unfallort', v)} />
        </div>
      </div>

      <div>
        <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Haftung</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-sm">
          <InputField
            label="Haftungsquote (%)"
            value={String(daten.haftungsquote)}
            onChange={v => set('haftungsquote', parseInt(v) || 100)}
            type="number"
            placeholder="100"
          />
        </div>
        <p className="text-[11px] text-gray-400 mt-1.5">Standard: 100 % (volle Haftung des Unfallgegners)</p>
      </div>
    </div>
  );
}
